<div class="grant-container">
  <img class="logo" src="/assets/images/header/logo.svg" alt="Logo">
  <img class="close" src="/assets/images/grants/close.svg" alt="Close icon" (click)="close()">
  <div class="grant">
    <img class="ex-img" src="/assets/images/footer/junta-ex.svg" alt="Junta Extremadura">
    <div class="grant-text" [innerHTML]="'grants_Data5' | i18n"></div>
    <div class="sexpe">
      <img class="sexpe-img" src="/assets/images/footer/sexpe.svg" alt="Sexpe">
      <img class="ue-img" src="/assets/images/footer/ue.svg" alt="UE">
    </div>
    <div class="txt-container">
      <div class="title" [innerHTML]="'grants_Data3' |i18n"></div>
      <div class="info" [innerHTML]="'grants_Data4' |i18n"></div>
    </div>
  </div>
</div>
